import { defaultMarkerSeriesOptions } from './options';
import { MarkerSeriesRenderer } from './renderer';
export class MarkerSeries {
    constructor() {
        this._renderer = new MarkerSeriesRenderer();
    }
    priceValueBuilder(plotRow) {
        // zero at the start because it should draw from zero (like a column)
        return [0, plotRow.value];
    }
    isWhitespace(data) {
        return data.value === undefined;
    }
    renderer() {
        return this._renderer;
    }
    update(data, options) {
        this._renderer.update(data, options);
    }
    defaultOptions() {
        return defaultMarkerSeriesOptions;
    }
}
export * from './data';
